import React from 'react';
import Container from 'react-bootstrap/Container';
import Navigation from '../components/navigation/Navigation';
import TopToolbar from "../components/toolbar/TopToolbar";
import Footer from './Footer';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import './Layout.scss';

/**
 * Component defining the workbench grid system.
 */
class Layout extends React.Component {

  render() {
    return (
      <Container fluid className="Layout no-padding">
        <Row className="LayoutMain" noGutters>
          <Col xl={2} lg={2} md={3} sm={12} xs={12} className="LayoutNavigationColumn">
            <Navigation/>
          </Col>
          <Col xl={10} lg={10} md={11} sm={12} xs={12} className="LayoutContentColumn">
            <TopToolbar/>
            <Container fluid className="LayoutContent">
              {this.props.children}
            </Container>
          </Col>
        </Row>
        <Row className="LayoutFooter">
          <Footer/>
        </Row>
      </Container>
    );
  }
}

export default Layout;
